import { create } from 'zustand';
import { initialCardState } from './constants';

type NewsletterStore = {
  cards: typeof initialCardState;

  toggleCardSelection: (key: string) => void;
  setInitialCards: () => void;
  setCards: (cards: typeof initialCardState) => void;
};

export const [useNewsletterStore] = create<NewsletterStore>(set => ({
  cards: initialCardState,

  toggleCardSelection: (key: string) =>
    set(state => ({
      cards: {
        ...state.cards,
        [key]: { ...state.cards[key], isSelected: !state.cards[key].isSelected }
      }
    })),

  setCards: (cards: typeof initialCardState) => set({ cards }),

  setInitialCards: () => set({ cards: initialCardState })
}));
